export enum LivePracticeTypeEnum {
  AUTO_ASSIGNMENT = 1,
  FIXED_ASSIGNMENT = 2,
  CHAPTER_PRACTICE = 3,
  FREE_PRACTICE = 4,
}

export enum LivePracticeModeEnum {
  ONLINE = 1,
  HYBRID = 2,
  OFFLINE = 3,
}

export enum MeetingPlatformEnum {
  ZOOM = 1,
  BBB = 2,
}

export enum LivePracticeFrequencyEnum {
  ONE_TIME = 1,
  RECURRING = 2,
}

export enum LivePracticeCategoryEnum {
  SCHEDULED = 1,
  ACTIVE = 3,
  COMPLETED = 5,
  CANCELLED = 6,
}

export enum StudentLivePracticeCategoryEnum {
  SCHEDULED = 1,
  ACTIVE = 3,
  COMPLETED = 5,
}

export enum LivePracticeStatusEnum {
  SCHEDULED = 1,
  STARTED = 2,
  COMPLETED = 3,
  RESCHEDULED = 4,
  CANCELLED = 5,
  AUTO_ENDED = 6,
  AUTO_CANCELLED = 7,
}

export enum LivePracticeCompletionStatusEnum {
  COMPLETED = 3,
  COMPLETED_BY_SUBSTITUTE = 4,
  CANCELLED = 6,
}

export enum MeetingRecordingStatusEnum {
  PENDING = 1,
  PROCESSING = 2,
  READY = 3,
  UNAVAILABLE = 4,
  FAILED = 5,
}
